<template>
  <div class="relative">
    <div @click="forceClose" :class="{ enabled: is_fixed }" class="outside_background"></div>
    <transition name="fade">
      <div v-if="show_spring_project_tooltip" class="tooltip is-flex is-align-items-center is-justify-content-center">
        <img @click="postAlert({ designator: 'spring_project', priority: 6 })" src="/baby.svg" class="tooltip_img">
        <div style="width: 10px"></div>
        <img @click="postAlert({  designator: 'spring_project_senior', priority: 5 })" src="/man.svg" class="tooltip_img">
        <div style="width: 10px"></div>
        <img @click="postAlert({ designator: 'spring_project_principal', priority: 4 })" src="/tie.svg" class="tie_img">
      </div>
    </transition>
    <div v-if="payload.resource_type == 'Applicant'" class="priority-width">
      <img @click="postAlert({ designator: 'priority_vetting', priority: 7 })" src="/suitcase.svg" class="btn" width="20px">
    </div>
    <div v-if="payload.resource_type == 'Company'">
      <img @click="postAlert({ designator: 'spring_project_companies', priority: 6 })" src="/suitcase.svg" class="btn" width="20px">
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'priority-vetting',
  props: ['payload'],
  data () {
    return {
      show_spring_project_tooltip: false,
      is_fixed: false
    }
  },
  methods: {
    showSpringProjectTooltip () {
      this.is_fixed = true
      this.show_spring_project_tooltip = true
    },
    onMouseOver () {
      this.show_spring_project_tooltip = true
    },
    onMouseLeave () {
      if (this.is_fixed) {
        return
      }
      this.show_spring_project_tooltip = false
    },
    forceClose () {
      this.is_fixed = false
      this.show_spring_project_tooltip = false
    },
    postAlert (params) {
      this.$network_utils.postAlert({
        designator: params.designator,
        title: params.designator,
        status: 'active',
        priority: params.priority,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id
      }).then(() => {
        this.$utils.emit('show_toast', { text: params.designator + ' נשלח בהצלחה' })
        this.forceClose()
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
  .priority-width {
    width: 25px;
  }
  .outside_background{
    position: fixed;
    pointer-events: none;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
  }
  .enabled{
    pointer-events: auto !important;
  }
  .tooltip{
    position: absolute;
    box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    background-color: #f9f9f9;
    border-radius: 20px;
    left: -50px;
    top: -40px;
    width: 130px;
    height: 40px;
  }
  .tie_img{
    cursor: pointer;
    width: 20px;
    height: 30px;
  }
  .tooltip_img{
    cursor: pointer;
    min-width: 20px !important;
    width: 20px !important;
  }
</style>
